import React, { useContext, useState } from 'react';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import { TitleProps as AntTitleProps } from 'antd/lib/typography/Title';
import { Input, notification, Typography } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import { AuthContext } from 'components/Auth/Auth';
import {
  ParPagComponentRequest,
  updatePageComponent,
} from 'services/displayFramework';
import { useNavigate } from 'react-router-dom';

const { Title: AntTitle } = Typography;

export type TitleProps = Omit<AntTitleProps, 'children'> & {
  comcode?: string;
  titleProps?: string;
  Inspectstyle?: React.CSSProperties;
  bgColor: 'green' | 'blue' | 'duck-blue' | 'purple';
  noTitleOverlay?: boolean;
  onPrev?: () => void;
};

const TitlePage = ({
  comcode,
  Inspectstyle,
  bgColor,
  noTitleOverlay,
  onPrev,
  titleProps,
  ...otherProps
}: TitleProps) => {
  const { isHidden, label, style } = useComponentConfiguration(comcode ?? '');
  const { pagcode, refresh } = useDisplayFrameworkContext();
  const { isInspect } = useContext(AuthContext);
  const [newLabel, setNewLabel] = useState('');
    const navigate = useNavigate();
  if (isHidden) {
    return null;
  }
  onPrev = onPrev ?? (() => {navigate(-1)});
  const handleSaveNewLabel = (comcode: string, labelp: string) => {
    const request: ParPagComponentRequest = {
      comcode: comcode ?? '',
      comformat: '',
      comhint: '',
      comlabel: newLabel === '' ? label : labelp,
      commessage: '',
      complaceholder: '',
      comrequired: false,
      comstyle: '',
      comtype: '',
      pagcode: pagcode ?? '',
    };
    updatePageComponent({ request: request }).then((res) => {
      if (res.code === '200')
        notification.success({
          message: res.message,
          description: res.description,
        });
      else {
        notification.error({
          message: res.message,
          description: res.description,
        });
      }
      refresh();
    });
  };

  const props = {
    ...otherProps,
    children: isInspect ? (
      <Input
        defaultValue={titleProps ?? label}
        size="middle"
        onChange={(event) => {
          event.preventDefault();
          setNewLabel(event.target.value);
        }}
        onClick={(event) => {
          event.preventDefault();
        }}
        style={Inspectstyle ?? { width: '100%' }}
        className="input-inspect"
        addonAfter={
          <SaveOutlined
            onClick={(ev) => {
              ev.preventDefault();
              handleSaveNewLabel(comcode ?? '', newLabel);
            }}
          />
        }
      />
    ) : (
      label
    ),
    style,
  };

  return (
    <div
      className={`ut-title-page ut-title-page-layout-1 ut-title-page-${bgColor} ${noTitleOverlay ? 'no-after' : ''
        }  `}
    >
      {onPrev && (
        <ArrowLeftOutlined
          className="text-white  font-size-24 floatLeft returnIcon mr-3"
          onClick={() => !isInspect && onPrev && onPrev()}
        />
      )}{' '}
      <AntTitle {...props} />
    </div>
  );
};

export default TitlePage;
